<template>
  <div class="td-index">
    <article class="td-index-main">
      <router-link class="td-index-back" :to="local('/work/')">← {{ zh ? '返回作品檔案' : 'Back to work' }}</router-link>
      <header class="td-index-head">
        <p class="td-index-kicker">TouchDesigner · {{ span }}</p>
        <h1>{{ zh ? 'TouchDesigner 每日創作' : 'TouchDesigner Daily' }}</h1>
        <p class="td-index-intro">{{ intro }}</p>
      </header>
      <ul class="td-index-grid">
        <li v-for="w in works" :key="w.slug">
          <router-link :to="local('/td/' + w.slug)">
            <img v-if="w.cover || w.poster" :src="w.cover || w.poster" :alt="w.title" loading="lazy" decoding="async" />
            <p>{{ w.date }}</p>
            <h2>{{ zh && w.titleZh ? w.titleZh : w.title }}</h2>
          </router-link>
        </li>
      </ul>
    </article>
    <td-course-card :zh="zh" content="index" placement="td-daily-index" />
  </div>
</template>
<script setup>
// /td/ 與 /zh/td/（2026-10-18）：TouchDesigner 每日創作的索引頁。之前只有 /td/<slug>/ 作品頁，索引網址是 404。
// 資料讀 src/data/td-catalog.json 的 public 作品（與 build-route-manifest 的 /td/<slug>/ 同一份）；頁底同一張課程卡。
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import catalog from '@/data/td-catalog.json'
import { sitePath } from '@/runtime/site-path.mjs'
import TdCourseCard from '@/components/td/TdCourseCard.vue'
const route = useRoute()
const zh = computed(() => route.path.startsWith('/zh/') || route.path === '/zh')
const local = (p) => sitePath(p, zh.value)
const works = catalog.works.filter((w) => w.public).sort((a, b) => b.date.localeCompare(a.date))
const years = works.map((w) => w.date.slice(0, 4))
const span = Math.min(...years) === Math.max(...years) ? years[0] : `${Math.min(...years)}–${Math.max(...years)}`
const intro = computed(() => zh.value
  ? `吳哲宇的 TouchDesigner 每日創作，${span} 年。這裡列出 ${works.length} 件作品，每一頁寫日期，有資料的再寫長度、工具和節點數。`
  : `Daily TouchDesigner works by Che-Yu Wu, ${span}. ${works.length} works are listed here. Each page gives the date, and the length, tools and node count where the record has them.`)
</script>
<style scoped>
.td-index { background: #080808; color: #f2eee5; font-family: var(--font-body); }
.td-index-main { padding: 52px max(24px, 5vw) 72px; max-width: 1840px; margin: auto; text-align: left; }
.td-index-back { color: var(--ink-3); font-size: 13px; text-decoration: none; display: inline-block; padding: 8px 0; }
.td-index-back:hover { color: var(--gold); }
.td-index-head { padding: 12px 0 44px; max-width: 46em; }
.td-index-kicker { font-size: 13px; color: #aaa396; margin: 0 0 14px; }
.td-index-head h1 { font-family: var(--font-slab), var(--font-display); font-size: clamp(34px, 4.4vw, 60px); font-weight: 500; line-height: 1.15; margin: 0 0 20px; }
.td-index-intro { margin: 0; color: #b8b5ad; font-size: 17px; line-height: 1.85; }
.td-index-grid { list-style: none; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 40px 32px; }
.td-index-grid a { display: block; color: inherit; text-decoration: none; }
.td-index-grid img { display: block; width: 100%; aspect-ratio: 4 / 5; object-fit: contain; background: #050505; }
.td-index-grid p { font-size: 12px; color: #aaa396; margin: 14px 0 6px; font-variant-numeric: tabular-nums; }
.td-index-grid h2 { font-family: var(--font-slab), var(--font-display); font-size: 21px; font-weight: 500; line-height: 1.35; margin: 0; }
.td-index-grid a:hover h2 { color: var(--gold); }
.td-index-grid a:focus-visible { outline: 2px solid var(--gold); outline-offset: 6px; }
@media (max-width: 1100px) { .td-index-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 760px) { .td-index-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 28px 16px; } }
</style>
